import React, { useState, useEffect } from "react"
import warningIcon from "images/warning.png"
import CenterModal from "components/presenters/modal/CenterModal"
import server from "server/serverController2"
import { useHistory } from "react-router-dom"
import { isValidPassword, getQueryStringObject } from "utils/utils"
import {
  EmailResetForm,
  FieldList,
  FormTitle,
  PasswordField,
  ErrorMessage,
  WarningImg,
} from "./style"

export default function PasswordResetForm({ isValid, setIsValid, setOnSubmit }) {
  const history = useHistory()

  const [isRequesting, setIsRequesting] = useState(false)
  const [password, setPassword] = useState("")
  const [passwordConfirm, setPasswordConfirm] = useState("")

  const [passwordErrMsg, setPasswordErrMsg] = useState(null)
  const [confirmErrMsg, setconfirmErrMsg] = useState(null)

  //Center Modal State
  const [initCenterModal, setInitCenterModal] = useState(false)
  const [centerModalVisible, setCenterModalVisible] = useState(false)
  const [centerModalDataList, setCenterModalDataList] = useState({})
  const [onModalComplete, setOnModalComplete] = useState(null)
  const [onModalCancel, setOnModalCancel] = useState(null)

  //Init Center Modal State
  useEffect(() => {
    if (initCenterModal === true) {
      setCenterModalVisible(false)
      setCenterModalDataList({})
      setOnModalComplete(null)
      setOnModalCancel(null)
      setInitCenterModal(false)
    }
  }, [initCenterModal])

  useEffect(() => {
    setOnSubmit(() => submitRequest)
  }, [])
  useEffect(() => {
    if (isValidPassword(password) && password === passwordConfirm) {
      setIsValid(true)
      setOnSubmit(() => submitRequest)
    } else {
      setIsValid(false)
    }
  }, [password, passwordConfirm])

  const submitRequest = () => {
    if (!isRequesting) {
      setIsRequesting(true)
      const urlQuery = getQueryStringObject()
      const form = { new_password: password, token: urlQuery["token"] }
      server.putRequestData(`users/${urlQuery["user_no"]}/password`, form, (res) => {
        if (res["success"] === 0) {
          let errData = res["error"]["res_data"]

          setIsRequesting(false)
          setCenterModalVisible(true)
          if (["TOKEN_MISMATCH", "TOKEN_EXPIRED"].includes(errData["detail_code"])) {
            setCenterModalDataList({
              description: "만료된 링크입니다. 다시 비밀번호 초기화 요청을 해주세요.",
            })
            setOnModalComplete(() => () => {
              setInitCenterModal(true)
              history.replace("/social")
            })
          } else {
            setCenterModalDataList({
              description:
                "비밀번호 초기화에 실패했습니다. 관리자 admin@unitmi.com 으로 문의해주세요.",
            })
            setOnModalComplete(() => () => {
              setInitCenterModal(true)
              history.replace("/social")
            })
          }
          return
        }

        setIsRequesting(false)
        setCenterModalVisible(true)
        setCenterModalDataList({
          description: `비밀번호를 초기화하였습니다. 다시 로그인 해주세요!`,
        })
        setOnModalComplete(() => () => {
          setInitCenterModal(true)
          history.replace("/social")
        })
      })
    }
  }

  const handlePasswordChange = (e) => {
    const inputData = e.target.value
    validatePassword(inputData)
    setPassword(inputData)
    if (passwordConfirm.length > 0 && inputData !== passwordConfirm) {
      setconfirmErrMsg("비밀번호가 일치하지 않았습니다. 다시 시도해 보세요.")
    } else {
      setconfirmErrMsg(null)
    }
  }

  const handlePasswordConfirmChange = (e) => {
    const inputData = e.target.value
    setPasswordConfirm(inputData)
    if (inputData !== password) {
      setconfirmErrMsg("비밀번호가 일치하지 않았습니다. 다시 시도해 보세요.")
    } else {
      setconfirmErrMsg(null)
    }
  }

  const validatePassword = (input) => {
    if (isValidPassword(input)) {
      setPasswordErrMsg(null)
    } else {
      setPasswordErrMsg("영문/숫자/특수기호 포함 8글자 이상 입력해주세요.")
    }
  }

  return (
    <EmailResetForm>
      <FieldList>
        <FormTitle>비밀번호</FormTitle>
        <PasswordField
          type="password"
          placeholder="영문/숫자/특수기호 포함 8글자 이상"
          onChange={handlePasswordChange}
        />
        {passwordErrMsg ? (
          <ErrorMessage>
            <WarningImg src={warningIcon} />
            {passwordErrMsg}
          </ErrorMessage>
        ) : (
          <ErrorMessage> </ErrorMessage>
        )}
      </FieldList>
      <FieldList>
        <FormTitle>비밀번호 확인</FormTitle>
        <PasswordField type="password" onChange={handlePasswordConfirmChange} />
        {confirmErrMsg ? (
          <ErrorMessage>
            <WarningImg src={warningIcon} />
            {confirmErrMsg}
          </ErrorMessage>
        ) : (
          <ErrorMessage> </ErrorMessage>
        )}
      </FieldList>
      <CenterModal
        modalVisible={centerModalVisible}
        setModalVisible={setCenterModalVisible}
        dataList={centerModalDataList}
        onCancel={onModalCancel}
        onComplete={onModalComplete}
      />
    </EmailResetForm>
  )
}
